import { Entry } from '../Entry'

export function Entry20251103() {
  return (
    <Entry title="2025 Nov 03 - v3.11.1">
      Link to the{' '}
      <a
        href="https://workwave.atlassian.net/projects/RM/versions/19804/tab/release-report-all-issues"
        target="_blank"
        rel="noreferrer"
      >
        Jira Release
      </a>
    </Entry>
  )
}
